import React, { useEffect, useState, useRef } from 'react';
import {
  MapPin,
  Clock,
  Users,
  CheckCircle2,
  XCircle,
  Minus,
  Plus,
  Hotel,
  Utensils,
  Car,
  Camera,
  Download,
  Phone,
  Star,
  Plane,
  ShieldCheck,
  Calendar,
  X,
  Mail,
  Check,
  Search,
  ChevronDown,
  BriefcaseBusiness,
} from 'lucide-react';
import isEqual from "lodash/isEqual";
import ShimmerLoaderAddons from '../../components/ShimmerLoaderAddons';
import "react-datepicker/dist/react-datepicker.css";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { getDetails, getcheckAvailability, getAddOn } from './HolidaySlice';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import PackageSkeleton from './PackageSkeleton';
import ItineraryDayCard from './ItineraryDayCard';
import {
  parseISO, isBefore, startOfDay, subDays,
  format
} from "date-fns";
import { useSearchParams, useLocation, useNavigate, useParams } from "react-router-dom";
import { selectCurrentUser } from '../auth/authSlice';
import PremiumSlider from './PremiumSlider';
import { Dialog } from "@headlessui/react";
import { DateInput } from "@mantine/dates";
import { getProposalURL, getcrmbaseURL } from '../../api/axios';

import CurFt from '../../components/CurFt';

const recalculatePackageData = (packageData) => {
  if (!packageData?.package) {
    return packageData;
  }

  const packageObj = packageData.package;

  // ---------------------------------------------------------
  // 1. Calculate total CAB price
  // ---------------------------------------------------------
  const totalCabPrice = (packageObj.itinerary || []).reduce(
    (total, itinerary) => {
      return total + parseFloat(
        itinerary?.selectedcabs?.totalPrice || 0
      );
    },
    0
  );

  // ---------------------------------------------------------
  // 2. Calculate total ACTIVITY price
  // ---------------------------------------------------------
  const totalActivityPrice = (packageObj.itinerary || []).reduce(
    (total, itinerary) => {
      const activityTotal = (itinerary?.activity || []).reduce(
        (activitySum, activity) => {
          return activitySum + parseFloat(
            activity?.price?.totalPrice || 0
          );
        },
        0
      );

      return total + activityTotal;
    },
    0
  );

  // ---------------------------------------------------------
  // 3. Calculate total SIGHTSEEING price
  // ---------------------------------------------------------
  const totalSightseeingPrice = (packageObj.itinerary || []).reduce(
    (total, itinerary) => {
      const sightseeingTotal = (
        itinerary?.sightseeings || []
      ).reduce(
        (sightseeingSum, sightseeing) => {
          return sightseeingSum + parseFloat(
            sightseeing?.price?.totalPrice || 0
          );
        },
        0
      );

      return total + sightseeingTotal;
    },
    0
  );
  const PackageCategory = (packageObj.PackageCategory);
  // ---------------------------------------------------------
  // 4. Recalculate a single rate
  // ---------------------------------------------------------
  const recalculateRate = (rate) => {
    const sharing = parseFloat(rate?.sharing || 1);

    // -----------------------------------------------------
    // Divide total component price by sharing
    // -----------------------------------------------------
    let cabprice = totalCabPrice / sharing;

    let activityprice = totalActivityPrice / sharing;

    let sightseeingprice = totalSightseeingPrice / sharing;
    if (PackageCategory === 0) {
      cabprice = (cabprice * sharing)
      activityprice = (activityprice * sharing)
      sightseeingprice = (sightseeingprice * sharing)
    }
    // Existing package price
    const package_price = parseFloat(rate?.package_price || 0);
    const markupAmount = parseFloat(rate?.markupAmount || 0);
    const flightFare = parseFloat(rate?.flightFare || 0);


    // -----------------------------------------------------
    // Before discount
    // -----------------------------------------------------
    const beforediscountprice =
      package_price +
      cabprice +
      activityprice +
      sightseeingprice + markupAmount + flightFare;

    // -----------------------------------------------------
    // Discount
    // 1 = Fixed
    // 2 = Percentage
    // -----------------------------------------------------
    const discount_type = parseFloat(
      rate?.discount_type || 0
    );

    const discount_value = parseFloat(
      rate?.discount_value || 0
    );

    let discountAmount = 0;

    if (discount_type === 2) {
      discountAmount =
        (beforediscountprice * discount_value) / 100;
    } else if (discount_type === 1) {
      discountAmount = discount_value;
    }

    // Don't allow discount greater than price
    discountAmount = Math.min(
      discountAmount,
      beforediscountprice
    );

    // -----------------------------------------------------
    // Final price
    // -----------------------------------------------------
    const final_price = beforediscountprice - discountAmount;

    return {
      ...rate,

      cabprice: parseFloat(
        cabprice.toFixed(2)
      ),

      activityprice: parseFloat(
        activityprice.toFixed(2)
      ),

      sightseeingprice: parseFloat(
        sightseeingprice.toFixed(2)
      ),

      beforediscountprice: parseFloat(
        beforediscountprice.toFixed(2)
      ),

      discountAmount: parseFloat(
        discountAmount.toFixed(2)
      ),

      final_price: parseFloat(
        final_price.toFixed(2)
      ),
    };
  };

  // ---------------------------------------------------------
  // 5. Update ALL RATES
  // ---------------------------------------------------------
  const updatedAllRates = (
    packageObj.allRates || []
  ).map((rate) => recalculateRate(rate));

  // ---------------------------------------------------------
  // 6. Update SELECTED CATEGORY
  // ---------------------------------------------------------
  // const updatedSelectedCategory =
  //   packageObj.selected_category
  //     ? recalculateRate(
  //       packageObj.selected_category
  //     )
  //     : null;

  const updatedSelectedCategory =
    packageObj.selected_category && updatedAllRates.length > 0
      ? {
        ...packageObj.selected_category,
        ...updatedAllRates[0],
      }
      : packageObj.selected_category;

  // ---------------------------------------------------------
  // 7. Return updated package data
  // ---------------------------------------------------------
  return {
    ...packageData,

    package: {
      ...packageObj,

      allRates: updatedAllRates,

      selected_category:
        updatedSelectedCategory,
    },
  };

};
export default function PackageDetails() {
  useDocumentTitle('Details Package');
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { packageID } = useParams();
  const [selectedHotels, setSelectedHotels] = useState({});
  const [updatedItinerary, setUpdatedItinerary] = useState([]);
  const [images, setImages] = useState([]);
  const [policyData, setpolicyData] = useState([]);
  const [max_pax_stay, setmax_pax_stay] = useState(0);
  const currencyRef = useRef(null);
  const [packageData, setPackageData] = useState(null);
  const [trimmedArray, setrimmedArray] = useState([]);
  const [searchQuery, setSearchQuery] = useState([]);
  const [ratecardIDs, setRatecardIDs] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector(selectCurrentUser);
  const [formData, setFormData] = useState({
    customer_id: user?.UserData?.id,
    title: "MR",
    firstName: user?.UserData.user?.fname || "",
    lastName: user?.UserData.user?.lname || "",
    TravelDate: new Date(),
    email: user?.UserData?.email,
    phoneCode: user?.UserData?.user?.countrycode || "91",
    mobile: user?.UserData?.mobile,
  });

  const [CheckPrice, setCheckPrice] = useState(false);
  const [PackagePrice, setPackagePrice] = useState(false);
  const [BookingURL, setBookingURL] = useState('');
  const [DownloadVoucherURL, setDownloadVoucherURL] = useState('');
  const [SelectedItinerary, setSelectedItinerary] = useState(null);
  const [ShareURL, setShareURL] = useState('');

  let postData = {
    packageID: packageID,
    adultCount: 1,
    categoryID: searchParams.get("cat"),
    ratecard: searchParams.get("ratecard"),
    searchId: searchParams.get("SearchId"),
    selected_hotels: JSON.parse(searchParams.get("hotelOptions")),
  }
  const fetchDetails = async (SelectedItinerary = null) => {
    setLoading(true)
    const updatedPostData = {
      ...postData,
      SelectedItinerary
    };
    try {
      const response = await dispatch(
        getDetails({ updatedPostData })
      ).unwrap();
      const Resultdata = response.data;
      if (Resultdata.status.success) {

        setLoading(false)
        setPackageData(Resultdata.data);
        setPackages(Resultdata.data.package.allRates);
        setpolicyData(Resultdata.data.bookingpolicy);
        setmax_pax_stay(Resultdata.data.package.selected_category.max_pax_stay);

        const start = Resultdata?.data?.package?.selected_category?.start_date;
        const end = Resultdata?.data?.package?.selected_category?.end_date;
        // Get today's date in local timezone (NOT UTC)
        const today = startOfDay(new Date());
        const todayFormatted = format(today, "yyyy-MM-dd");
        let finalStartDate = start;
        if (start) {
          const parsedStart = startOfDay(parseISO(start));

          if (isBefore(parsedStart, today)) {
            finalStartDate = todayFormatted;
          }
        }
        setFormData((prev) => ({
          ...prev,
          ["TravelDate"]: finalStartDate,
          ["start_date"]: finalStartDate,
          ["end_date"]: end || null,
        }));
        setSearchQuery(Resultdata.data.searchQuery);
        const included = Resultdata.data?.inclusions;
        const trimmedArray = included.map(item => item.trim());
        setrimmedArray(trimmedArray)
      } else {
        setLoading(true)
        toast.error(Resultdata.message, { autoClose: 3000 });
      }
    } catch (error) {
      setLoading(true)
      toast.error('Unbale to load details', { autoClose: 3000 });
    }
  }
  // Auto slide
  useEffect(() => {
    fetchDetails()
  }, []);
  const lastComputedRef = useRef(null);
  useEffect(() => {
    if (packageData) {
      if (packageData?.package?.images) {
        const imageArray = packageData.package.images
          .map(img => img.trim())
          .filter(img => img.length > 0);
        if (packageData.package.Photo) {
          imageArray.unshift(packageData.package.Photo);
        }
        setImages(imageArray.length > 0 ? imageArray : ['/placeholder.png']);
      }

      const uniqueHotels = [
        ...new Map(
          (packageData?.package?.itinerary || [])
            .flatMap(day => day?.all_hotel_options || [])
            .map(hotel => [hotel.hotel_id, hotel])
        ).values()
      ];
      setSelectedHotels(uniqueHotels);
      let ratecardIDs = [];
      const updatedItinerary = packageData?.package?.itinerary.map((day) => {
        if (!day.all_hotel_options || day.all_hotel_options.length === 0) {
          return {
            ...day,
            selectedHotel: null
          };
        }
        // Find hotel with lowest star_rating
        const lowestStarHotel = day.all_hotel_options.reduce((lowest, current) => {
          return current.star_rating < lowest.star_rating ? current : lowest;
        });
        if (lowestStarHotel?.rate_card_id) {
          ratecardIDs.push(lowestStarHotel.rate_card_id);
        }
        return {
          ...day,
          selectedHotel: lowestStarHotel
        };
      })

      setUpdatedItinerary(updatedItinerary);

      setRatecardIDs(packageData?.package?.selected_category?.ratecardIDs || ratecardIDs);
      setFormData((prev) => ({
        ...prev,
        // ["TravelDate"]: (searchQuery?.searchQuery?.DepartureCriteria?.checkinDate || null),
        ["FromCity"]: packageData?.package?.dep_city_name,
        ["ToCIty"]: packageData?.package?.des_city_name,
      }));
      if (packageData?.package.PackageCategory === 2) {
        setRooms([{
          roomNo: 1,
          adults: searchQuery?.searchQuery?.searchCriteria?.adults || 1,
          childWithBed: 0,
          childWithoutBed: 0,
          infants: 0,
          max_pax_stay: packageData?.package?.selected_category?.max_pax_stay || 10,
        },
        ]);
      } else {
        setRooms([{
          roomNo: 1,
          adults: searchQuery?.searchQuery?.searchCriteria?.adults || 1,
          childWithBed: 0,
          childWithoutBed: 0,
          infants: 0,
          max_pax_stay: packageData?.package?.selected_category?.max_pax_stay || 1,
        },
        ]);
      }

      const updated = recalculatePackageData(packageData);

      const selectedItinerary = updated.package.itinerary.reduce(
        (result, item) => {
          result[item.days] = {
            selectedcab: item?.selectedcabs?.vehicle?.id || null,
            activity: (item.activity || [])
              .map(activity => activity?.activity?.id || null)
              .filter(Boolean),
            sightseeings: (item.sightseeings || [])
              .map(sightseeing => sightseeing?.sightseeing?.id || null)
              .filter(Boolean)
          };

          return result;
        },
        {}
      );

      setSelectedItinerary(selectedItinerary);

      // if (!isEqual(updated, lastComputedRef.current)) {
      //   lastComputedRef.current = updated;
      //   setPackageData(updated);
      // }
    }
  }, [packageData]);

  // tomorrow date
  // format helpers
  const formatStoreDate = (date) =>
    date.toISOString().split("T")[0]; // YYYY-MM-DD

  const formatDisplayDate = (date) =>
    date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });

  const [selectedTab, setSelectedTab] = useState(0);
  const overviewRef = useRef(null);
  const itineraryRef = useRef(null);
  const inclusionRef = useRef(null);
  const additionalRef = useRef(null);

  const scrollToSection = (ref, id) => {
    setSelectedTab(id)
    const yOffset = -80; // header height
    const y =
      ref.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;

    window.scrollTo({ top: y, behavior: "smooth" });
  };
  const TabCategories = [
    { name: "Overview", ref: overviewRef, id: 0 },
    { name: "Day Wise Itinerary", ref: itineraryRef, id: 1 },
    { name: "Inclusion/Exclusions", ref: inclusionRef, id: 2 },
    { name: "Additional Info", ref: additionalRef, id: 3 }
  ];

  const [isModalOpen, setIsModal] = useState(false);
  const [loadingpoup, setloadingpoup] = useState(false);
  const [action, setaction] = useState('');
  const EnquiryHand = (action) => {
    setIsModal(true);
    setaction(action);
  };
  const handleChange = (eOrName: any, value?: any) => {
    if (typeof eOrName === "string") {
      // Case: custom components like DateInput
      setFormData((prev) => ({
        ...prev,
        [eOrName]: value,
      }));
    } else {
      // Case: normal <input />, <select />, etc.
      const e = eOrName;
      setFormData((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const [rooms, setRooms] = useState([
    {
      roomNo: 1,
      adults: 2,
      childWithBed: 0,
      childWithoutBed: 0,
      infants: 0,
      max_pax_stay: max_pax_stay,
    },
  ]);

  const updateRoomPax = (index, field, value) => {
    setRooms(prev =>
      prev.map((room, i) => {
        if (i !== index) return room;

        const updatedRoom = { ...room, [field]: Math.max(0, value) };
        const totalPax = getTotalPax(updatedRoom);

        // ❌ Block increase if max_pax_stay exceeded
        if (totalPax > room.max_pax_stay) {
          return room; // revert change
        }

        return updatedRoom;
      })
    );
  };

  const addRoom = () => {
    setRooms(prev => [
      ...prev,
      {
        roomNo: prev.length + 1,
        adults: 2,
        childWithBed: 0,
        childWithoutBed: 0,
        infants: 0,
        max_pax_stay: max_pax_stay,
      },
    ]);
  };
  const getTotalPax = (room) => room.adults + room.childWithBed + room.childWithoutBed + room.infants;
  const removeRoom = (index) => {
    setRooms(prev => prev.filter((_, i) => i !== index));
  };
  const closePopup = () => setCheckPrice(false);
  const [showBreakup, setShowBreakup] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    const title = formData.title.trim();
    const firstName = formData.firstName.trim();
    const lastName = formData.lastName.trim();
    const email = formData.email.trim();
    const phoneCode = formData.phoneCode;
    const mobile = formData.mobile.trim();

    if (!title || !firstName || !lastName || !email || !mobile) {
      toast.error('Please fill all required fields');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error('Please enter a valid email address');
      return;
    }

    if (mobile.length < 10) {
      toast.error('Please enter a valid mobile number (minimum 10 digits)');
      return;
    }

    const inquiryData = {
      PlanType: 3,
      BookingType: 2,
      BookingID: postData.searchId,
      packageID: packageID,
      categoryID: postData.categoryID,
      ratecard: postData.ratecard,
      selectedHotels: selectedHotels,
      rooms: rooms,
      fname: firstName,
      lname: lastName,
      email: email,
      countrycode: formData.phoneCode,
      mobile: mobile,
      // category: selectedCategory?.name || '',
      FromCity: formData?.FromCity,
      ToCIty: formData?.ToCIty,
      Defaultb2b: 1,
      leadsource: 12,
      adult: 1,
      child: 0,
      childwob: 0,
      infant: 0,
      title: title,
      TravelDate: formData.TravelDate,
      ratecardIDs: ratecardIDs,
      action: (action === 'BOOK') ? 2 : 1,
      allRates: packages,
      SelectedItinerary: SelectedItinerary
    };

    try {
      setloadingpoup(true);
      const response = await dispatch(
        getcheckAvailability({ inquiryData })
      ).unwrap();
      const Resultdata = response.data;
      if (Resultdata.status.success) {
        setBookingURL(Resultdata.encripted)
        setDownloadVoucherURL(Resultdata.DownloadVoucherURL)
        setShareURL(Resultdata.whatsappUrl)
        setPackagePrice(Resultdata.PackagePrice)
        setCheckPrice(true)
        setIsModal(false);
        setloadingpoup(false)
        toast.success(Resultdata.message, { autoClose: 3000 });
      } else {
        setloadingpoup(false)
        toast.error(Resultdata.message, { autoClose: 3000 });
      }
    } catch (error) {
      setloadingpoup(false)
      toast.error('Unbale fetch details', { autoClose: 3000 });
    }
  };
  function objectToQueryString(obj) {
    return Object.keys(obj)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
      .join('&');
  }
  const initialFormData = {
    displayServiceFee: 1,
    isVoucher: 2,
    action: 0,
    showPrice: true,
    withBranding: true,
    tax: true,
    withtnc: true,
    hoteldetails: true,
    Itinerary: true,
  };
  const DownloadItinerary = (action) => {
    const queryString = objectToQueryString(initialFormData);
    window.open('/Holidays/print-voucher/' + BookingURL + '?action=1&' + queryString, '_blank', 'noopener,noreferrer');
    // window.open(DownloadVoucherURL + '?action=1&' + queryString, '_blank', 'noopener,noreferrer');
  }
  const ShareonWhatsApp = (action) => {
    window.open(ShareURL, '_blank', 'noopener,noreferrer');
  }

  const Continuetopay = (action) => {
    window.open('/Holidays/booking/' + BookingURL, '_blank', 'noopener,noreferrer');
  }
  const maxDate = (formData?.end_date && packageData?.package?.PackageCategory === 0) ? subDays(parseISO(formData?.end_date || null), parseInt(packageData?.package?.PackageDuration) || 0) : (formData?.end_date ?? null);

  const [packages, setPackages] = useState(packageData?.package?.allRates || []);

  const MAX_ADULTS = 100;
  const MIN_ADULTS = 1;
  // Add Adult
  const handleAddAdult = (index) => {
    setPackages((prevPackages) => {

      // Total current adults
      const totalAdults = prevPackages.reduce(
        (sum, pkg) => sum + Number(pkg.adults || 0),
        0
      );

      // Prevent exceeding max limit
      if (totalAdults >= MAX_ADULTS) {
        alert(`Maximum ${MAX_ADULTS} pax allowed`);
        return prevPackages;
      }

      return prevPackages.map((pkg, i) =>
        i === index
          ? { ...pkg, adults: Number(pkg.adults || 0) + 1 }
          : pkg
      );
    });
  };


  // Remove Adult
  const handleRemoveAdult = (index) => {
    setPackages((prevPackages) => {

      const totalAdults = prevPackages.reduce(
        (sum, pkg) => sum + Number(pkg.adults || 0),
        0
      );

      const currentAdults = Number(prevPackages[index].adults || 0);

      // Prevent removing below minimum overall count
      if (totalAdults <= MIN_ADULTS && currentAdults > 0) {
        alert(`At least ${MIN_ADULTS} adult required`);
        return prevPackages;
      }

      return prevPackages.map((pkg, i) =>
        i === index && currentAdults > 0
          ? { ...pkg, adults: currentAdults - 1 }
          : pkg
      );
    });
  };
  const [isOpen, setIsOpen] = useState(false);
  const [LoadingUpdate, setLoadingUpdate] = useState(false);
  const [LoadingAddon, setLoadingAddon] = useState(false);
  const [activeTab, setActiveTab] = useState('ACTIVITY');
  const [selectedId, setSelectedId] = useState(0);
  const [selectedCab, setSelectedIdCab] = useState(null);
  const [SelectedActivity, setSelectedActivity] = useState(null);
  const [SelectedSight, setSelectedSight] = useState(null);
  const [AddVehicle, setAddVehicle] = useState([]);
  const [selectedDays, setselectedDays] = useState(0);
  const [dayData, setdayData] = useState(null);
  const [selectedKey, setselectedKey] = useState(0);
  const [AddSightseeing, setAddSightseeing] = useState([]);
  const [AddActivities, setAddActivities] = useState([]);


  const SelectedIdCab = (item) => {

    const price = item?.price;

    const formattedData = {
      id: item?.mst_vehicle_id,
      AgencyID: price?.AgencyID,
      UserSysId: price?.UserSysId,
      name: price?.name,
      Currency: price?.Currency,
      Supplier: price?.Supplier,
      vehicle_type: price?.vehicle_type,
      vehicle_id: price?.vehicle_id,
      from_date: price?.from_date,
      to_date: price?.to_date,
      booking_basis: price?.booking_basis,
      max_pax_capacity: price?.max_pax_capacity,
      max_luggage_capacity: price?.max_luggage_capacity,
      allocation: price?.allocation,
      CPAge: price?.CPAge,
      CFAge: price?.CFAge,
      b2b_ad_cost: price?.b2b_ad_cost,
      b2c_ad_cost: price?.b2c_ad_cost,
      b2b_markup: price?.b2b_markup,
      b2c_markup: price?.b2c_markup,
      b2b_CP_cost: price?.b2b_CP_cost,
      b2c_CP_cost: price?.b2c_CP_cost,
      b2b_CF_cost: price?.b2b_CF_cost,
      b2c_CF_cost: price?.b2c_CF_cost,
      baseFare: price?.baseFare,
      totalPrice: price?.totalPrice,
      TotalMarkup: price?.TotalMarkup,
      TotalGST: price?.TotalGST,
      is_active: price?.is_active,
      Duration: price?.Duration,
      booking_included: price?.booking_included,
      availabletime: price?.availabletime,
      Summary: price?.Summary,
      created_at: price?.created_at,
      updated_at: price?.updated_at,
      newAdded: true,

      vehicle: {
        id: item?.id,
        AgencyID: item?.AgencyID,
        UserSysId: item?.UserSysId,
        mst_vehicle_id: item?.mst_vehicle_id,
        name: item?.name,
        price: null,
        seating_capacity: item?.seating_capacity,
        IsAc: item?.IsAc,
        vehicle_number: item?.vehicle_number,
        noOfvehicle: item?.noOfvehicle,
        image: item?.image,
        isActive: item?.isActive,
        created_at: item?.created_at,
        updated_at: item?.updated_at,
        vehicle_type: item?.vehicle_type,
      },
    };
    setSelectedIdCab(formattedData);
    const updatedPackageData = {
      ...packageData,
      package: {
        ...packageData.package,
        itinerary: packageData.package.itinerary.map((item) =>
          item.days === selectedDays
            ? {
              ...item,
              selectedcabs: formattedData,
            }
            : item
        ),
      },
    };
    setPackageData(updatedPackageData)
    // console.log(formattedData);

  }

  const SelectActivity = (activity, index) => {
    let itineraryId = dayData.itinerary_id;
    let holidayPackageId = dayData.holiday_package_id;
    const formattedData = {
      newAdded: true,
      id: activity.price?.id ?? null,
      holiday_package_id: holidayPackageId ?? null,
      itinerary_id: itineraryId ?? null,
      mst_activities_id: activity.id,

      nat_adult_amount: activity.price?.nat_adult_amount ?? "0.00",
      nat_adult_markup: activity.price?.nat_adult_markup ?? "0.00",
      nat_child_amount: activity.price?.nat_child_amount ?? "0.00",
      nat_child_markup: activity.price?.nat_child_markup ?? "0.00",

      activity: {
        id: activity.id,
        activity_name: activity.activity_name,
        name: activity.activity_name,

        activity_type: activity.activity_type
          ? {
            id: activity.activity_type.id,
            name: activity.activity_type.name,
          }
          : null,

        activity_category: activity.activity_category,
        about_activity: activity.about_activity,
        includes: activity.includes,
        please_note: activity.please_note,
        is_transfer: activity.is_transfer,
        activity_level: activity.activity_level,

        country: activity.country
          ? {
            id: activity.country.id,
            name: activity.country.name,
          }
          : null,

        state: typeof activity.state === "object"
          ? activity.state
          : {
            id: activity.state,
          },

        city: activity.city
          ? {
            id: activity.city.id,
            cityName: activity.city.cityName,
            countryName: activity.city.countryName,
            fullRegionName: activity.city.fullRegionName,
          }
          : null,

        lat: activity.lat,
        lon: activity.lon,
        details: activity.details,
        advisory: activity.advisory,
        confirmation_policy: activity.confirmation_policy,
        cancellation_policy: activity.cancellation_policy,
        duration: activity.duration,
        is_active: activity.is_active,

        images: activity.images ?? [],
      },

      price: {
        id: activity.price?.id ?? null,
        mst_activities_id: activity.price?.mst_activities_id ?? activity.id,

        booking_included: activity.price?.booking_included ?? null,

        nat_adult_amount: activity.price?.nat_adult_amount ?? "0.00",
        nat_adult_markup: activity.price?.nat_adult_markup ?? "0.00",
        nat_child_amount: activity.price?.nat_child_amount ?? "0.00",
        nat_child_markup: activity.price?.nat_child_markup ?? "0.00",

        baseFare: activity.price?.baseFare ?? 0,
        totalPrice: activity.price?.totalPrice ?? 0,
        TotalMarkup: activity.price?.TotalMarkup ?? 0,
        TotalGST: activity.price?.TotalGST ?? 0,
      },
    };
    setSelectedActivity(formattedData);
    const activityIdToReplace = selectedKey;

    // const updatedPackageData = {
    //   ...packageData,
    //   package: {
    //     ...packageData.package,

    //     itinerary: packageData.package.itinerary.map(item =>
    //       item.days === selectedDays
    //         ? {
    //           ...item,
    //           activity: (item.activity || []).map((activity, key) =>
    //             key === activityIdToReplace
    //               ? formattedData
    //               : activity
    //           )
    //         }
    //         : item
    //     )
    //   }
    // };
    // const updatedPackageData = {
    //   ...packageData,
    //   package: {
    //     ...packageData.package,

    //     itinerary: packageData.package.itinerary.map(item =>
    //       item.days === selectedDays
    //         ? {
    //           ...item,
    //           activity:
    //             item.activity && item.activity.length > 0
    //               ? item.activity.map((activity, key) =>
    //                 key === activityIdToReplace
    //                   ? formattedData
    //                   : activity
    //               )
    //               : [formattedData]
    //         }
    //         : item
    //     )
    //   }
    // };

    // setPackageData(updatedPackageData)

    const updatedPackageData = {
      ...packageData,
      package: {
        ...packageData.package,

        itinerary: packageData.package.itinerary.map(item =>
          item.days === selectedDays
            ? {
              ...item,
              activity:
                item.activity && item.activity.length > 0
                  ? [...item.activity, formattedData]
                  : [formattedData]
            }
            : item
        )
      }
    };

    setPackageData(updatedPackageData);
  };
  const removeActivity = (items, dayData, day, type, key = 0) => {

    setdayData(dayData);
    setselectedDays(day);
    setselectedKey(key);
    setActiveTab(type);
    let updatedPackageData = null;
    if (type === 'ACTIVITY') {
      updatedPackageData = {
        ...packageData,
        package: {
          ...packageData.package,

          itinerary: packageData.package.itinerary.map(item =>
            item.days === day
              ? {
                ...item,
                activity: (item.activity || []).filter(
                  activity => activity.mst_activities_id !== parseInt(items.mst_activities_id)
                )
              }
              : item
          )
        }
      };
      setPackageData(updatedPackageData);
    }
    if (type === 'SIGHTSEEING') {
      updatedPackageData = {
        ...packageData,
        package: {
          ...packageData.package,

          itinerary: packageData.package.itinerary.map(item =>
            item.days === day
              ? {
                ...item,
                sightseeings: (item.sightseeings || []).filter(
                  activity => activity.mst_sightseeing_id !== parseInt(items.mst_sightseeing_id)
                )
              }
              : item
          )
        }
      };
      setPackageData(updatedPackageData);
    }
    if (type === 'TRANSFERS') {
      updatedPackageData = {
        ...packageData,
        package: {
          ...packageData.package,

          itinerary: packageData.package.itinerary.map(item =>
            item.days === day
              ? {
                ...item,
                selectedcabs: null
              }
              : item
          )
        }
      };
      setPackageData(updatedPackageData);
    }

    setTimeout(() => {
      const selectedItinerary = updatedPackageData.package.itinerary.reduce(
        (result, item) => {
          result[item.days] = {
            selectedcab: item?.selectedcabs?.vehicle?.id || null,
            activity: (item.activity || [])
              .map(activity => activity?.activity?.id || null)
              .filter(Boolean),
            sightseeings: (item.sightseeings || [])
              .map(sightseeing => sightseeing?.sightseeing?.id || null)
              .filter(Boolean)
          };

          return result;
        },
        {}
      );
      fetchDetails(selectedItinerary)
    }, 1000);

  };

  const SelectSightseeing = (source, index) => {
    const overrides = null;
    const price = source.price || {};
    let itineraryId = dayData.itinerary_id;
    let holidayPackageId = dayData.holiday_package_id;
    const formattedData = {
      newAdded: true,
      // Not derivable from source — caller must supply via overrides
      id: overrides?.id ?? null,
      holiday_package_id: holidayPackageId ?? null,
      itinerary_id: itineraryId ?? null,

      // Maps 1:1 to the source sightseeing record's own id
      mst_sightseeing_id: source.id ?? null,

      // Pricing fields duplicated at the top level
      nat_adult_amount: price.nat_adult_amount ?? "0.00",
      nat_adult_markup: price.nat_adult_markup ?? "0.00",
      nat_child_amount: price.nat_child_amount ?? "0.00",
      nat_child_markup: price.nat_child_markup ?? "0.00",

      sightseeing: {
        id: source.id ?? null,
        AgencyID: source.AgencyID ?? null,
        UserSysId: source.UserSysId ?? null,
        country_id: source.country_id ?? null,

        // Source only gives a bare state id (e.g. `state: 8`).
        // Full state object isn't available here, so default the rest.
        state: {
          id: source.state ?? null,
          stateId: overrides?.stateId ?? null,
          countryid: source.country_id ?? null,
          name: overrides?.stateName ?? null,
          CircleCode: 0,
        },

        city: source.city
          ? {
            id: source.city.id ?? null,
            cityName: source.city.cityName ?? null,
            countryName: source.city.countryName ?? null,
            fullRegionName: source.city.fullRegionName ?? null,
          }
          : {
            id: null,
            cityName: null,
            countryName: null,
            fullRegionName: null,
          },

        sightseeing_type: source.sightseeing_type
          ? {
            id: source.sightseeing_type.id ?? null,
            name: source.sightseeing_type.name ?? null,
          }
          : { id: null, name: null },

        name: source.name ?? "",
        duration: source.duration ?? "",
        latitude: source.latitude ?? null,
        longitude: source.longitude ?? null,
        address: source.address ?? "",
        images: source.images ?? "",
        description: source.description ?? "",
        canpolicy: source.canpolicy ?? "",
        refundpolicy: source.refundpolicy ?? "",
        advisory: source.advisory ?? null,
        tems_condition: source.tems_condition ?? "",
        is_active: source.is_active ?? 0,
        is_deleted: source.is_deleted ?? 0,
        created_at: source.created_at ?? null,
        updated_at: source.updated_at ?? null,

        country: source.country
          ? {
            id: source.country.id ?? null,
            name: source.country.name ?? null,
            tjId: source.country.tjId ?? null,
            dialCode: source.country.dialCode ?? null,
            code: source.country.code ?? null,
            isoCode: source.country.isoCode ?? null,
          }
          : {
            id: null,
            name: null,
            tjId: null,
            dialCode: null,
            code: null,
            isoCode: null,
          },
      },

      price: {
        id: price.id ?? null,
        mst_activities_id: price.mst_activities_id ?? null,
        booking_included: price.booking_included ?? "",
        nat_adult_amount: price.nat_adult_amount ?? "0.00",
        nat_adult_markup: price.nat_adult_markup ?? "0.00",
        nat_child_amount: price.nat_child_amount ?? "0.00",
        nat_child_markup: price.nat_child_markup ?? "0.00",
        baseFare: price.baseFare ?? 0,
        totalPrice: price.totalPrice ?? 0,
        TotalMarkup: price.TotalMarkup ?? 0,
        TotalGST: price.TotalGST ?? 0,
      },
    };
    setSelectedSight(formattedData);
    const activityIdToReplace = selectedKey;
    // const updatedPackageData = {
    //   ...packageData,
    //   package: {
    //     ...packageData.package,

    //     itinerary: packageData.package.itinerary.map(item =>
    //       item.days === selectedDays
    //         ? {
    //           ...item,
    //           sightseeings:
    //             item.sightseeings && item.sightseeings.length > 0
    //               ? item.sightseeings.map((activity, key) =>
    //                 key === activityIdToReplace
    //                   ? formattedData
    //                   : activity
    //               )
    //               : [formattedData]
    //         }
    //         : item
    //     )
    //   }
    // };

    const updatedPackageData = {
      ...packageData,
      package: {
        ...packageData.package,

        itinerary: packageData.package.itinerary.map(item =>
          item.days === selectedDays
            ? {
              ...item,
              sightseeings:
                item.sightseeings && item.sightseeings.length > 0
                  ? [...item.sightseeings, formattedData]
                  : [formattedData]
            }
            : item
        )
      }
    };
    setPackageData(updatedPackageData)
  };
  const handleChangeAddOn = async (item, dayData, day, type, key = 0) => {

    setdayData(dayData);
    setselectedDays(day);
    setselectedKey(key);
    setActiveTab(type);
    if (type === 'TRANSFERS') {
      setSelectedIdCab(item);
    } else if (type === 'ACTIVITY') {
      setSelectedActivity(item);
    } else if (type === 'SIGHTSEEING') {
      setSelectedSight(item);
    }


    setIsOpen(true)
    let postData = {
      packageID: packageID,
      DestinationCovered: packageData?.package?.DestinationCovered,
    }
    setLoadingAddon(true)

    try {
      const response = await dispatch(
        getAddOn({ postData })
      ).unwrap();
      const Resultdata = response.data;
      if (Resultdata.status.success) {
        setLoadingAddon(false)
        setAddSightseeing(Resultdata?.data?.Sightseeing);
        setAddActivities(Resultdata?.data?.Activities);
        setAddVehicle(Resultdata?.data?.Vehicle);
      } else {
        setLoadingAddon(false)
        toast.error(Resultdata.message, { autoClose: 3000 });
      }
    } catch (error) {
      setLoadingAddon(false)
      toast.error('Unbale to load add ons', { autoClose: 3000 });
    }
  }

  const updateDetails = async () => {
    setIsOpen(false)
    fetchDetails(SelectedItinerary)
  }

  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">
        <main className="max-w-7xl mx-auto ">
          <div className="bg-white min-h-screen font-sans">
            {isOpen && (
              <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/40 backdrop-blur-xs p-4">
                <div className="relative flex flex-col w-full max-w-3xl max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
                  {/* Header */}
                  {LoadingAddon ? (
                    <><ShimmerLoaderAddons /></>
                  ) : (
                    <>
                      <div className="p-4 pb-2 border-b border-gray-100">
                        <button
                          type="button"
                          onClick={() => setIsOpen(false)}
                          className="absolute top-5 right-5 text-sky-500 hover:text-sky-600 transition-colors cursor-pointer"
                        >
                          <X className="w-6 h-6" />
                        </button>
                        <h2 className="text-md font-bold text-gray-900">Add Activity, Meal or Transfer</h2>
                        {/* <p className="text-sm font-medium text-gray-500 mt-1">Sep 27, 2 Adults</p> */}

                        {/* Navigation Tabs */}
                        <div className="flex gap-8 mt-5 border-b border-gray-200">
                          <button
                            type="button"
                            onClick={() => setActiveTab('ACTIVITY')}
                            className={`pb-3 text-sm font-bold tracking-wide transition-colors relative cursor-pointer ${activeTab === 'ACTIVITY' ? 'text-blue-600' : 'text-gray-700 hover:text-gray-900'
                              }`}
                          >
                            ACTIVITY
                            {activeTab === 'ACTIVITY' && (
                              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
                            )}
                          </button>
                          <button
                            type="button"
                            onClick={() => setActiveTab('SIGHTSEEING')}
                            className={`pb-3 text-sm font-bold tracking-wide transition-colors relative cursor-pointer ${activeTab === 'ACTIVITY' ? 'text-blue-600' : 'text-gray-700 hover:text-gray-900'
                              }`}
                          >
                            SIGHTSEEING
                            {activeTab === 'SIGHTSEEING' && (
                              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
                            )}
                          </button>

                          <button
                            type="button"
                            onClick={() => setActiveTab('TRANSFERS')}
                            className={`pb-3 text-sm font-bold tracking-wide transition-colors relative cursor-pointer ${activeTab === 'TRANSFERS' ? 'text-blue-600' : 'text-gray-700 hover:text-gray-900'
                              }`}
                          >
                            TRANSFERS
                            {activeTab === 'TRANSFERS' && (
                              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-blue-600 rounded-full" />
                            )}
                          </button>
                        </div>
                      </div>
                      {activeTab === 'ACTIVITY' && (
                        <>
                          {/* Filters and Search Bar */}
                          {/* <div className="p-4 py-2 bg-white flex flex-wrap items-center justify-between gap-4">
                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-semibold text-gray-700">Category</label>
                              <div className="relative">
                                <select className="appearance-none bg-sky-50/60 border border-sky-200 text-blue-600 text-sm font-semibold rounded-lg px-3 py-1.5 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer">
                                  <option>Any</option>
                                  <option>Sightseeing</option>
                                  <option>Workshop</option>
                                  <option>Dining</option>
                                </select>
                                <ChevronDown className="w-4 h-4 text-blue-500 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
                              </div>
                            </div>

                            <div className="flex items-center gap-3">
                              <div className="relative">
                                <Search className="w-4 h-4 text-sky-500 absolute left-3 top-1/2 -translate-y-1/2" />
                                <input
                                  type="text"
                                  placeholder="Search activities"
                                  className="pl-9 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg w-48 sm:w-56 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                              </div>

                              <button type="button" className="flex items-center gap-1 text-sm font-semibold text-gray-800 hover:text-gray-900 cursor-pointer">
                                Sort by <ChevronDown className="w-4 h-4 text-blue-500" />
                              </button>
                            </div>
                          </div> */}

                          {/* Scrollable Content Body */}
                          <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-4">
                            {activeTab === 'ACTIVITY' ? (
                              AddActivities.length > 0 && AddActivities.map((item, index) => {
                                const isSelected = SelectedItinerary?.[selectedDays]?.activity?.includes(item.id)// SelectedActivity?.mst_activities_id === item.id;
                                return (
                                  <div
                                    key={item.id}
                                    className="flex flex-col sm:flex-row gap-4 p-4 border border-gray-200 rounded-2xl bg-white shadow-xs hover:shadow-md transition-shadow"
                                  >
                                    <img
                                      src={item?.images?.[0]?.image || "/placeholder.png"}
                                      onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = "/placeholder.png"; // path to your placeholder image
                                      }}
                                      alt={item.activity_name}
                                      className="w-full sm:w-44 h-36 rounded-xl object-cover shrink-0"
                                    />

                                    <div className="flex-1 flex flex-col justify-between">
                                      <div>
                                        <h4 className="text-base font-bold text-gray-900">{item.activity_name} ({item?.activity_type?.name})</h4>
                                        <div className="text-xs text-gray-600 mt-1 line-clamp-2 leading-relaxed">
                                          <div
                                            className="text-gray-700 text-sm"
                                            dangerouslySetInnerHTML={{ __html: item.about_activity }}
                                          />
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium mt-2">
                                          <Clock className="w-3.5 h-3.5 text-gray-500" />
                                          <span>{item.duration}</span>
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-700 font-medium mt-1">
                                          <Car className="w-3.5 h-3.5 text-gray-600 stroke-[3]" />
                                          <span>{item?.price?.booking_included}</span>
                                        </div>
                                      </div>

                                      <div className="mt-2">
                                        <button type="button" className="text-xs font-semibold text-blue-600 hover:underline cursor-pointer">
                                          Know More
                                        </button>
                                      </div>
                                    </div>

                                    {/* Pricing and Action */}
                                    <div className="flex sm:flex-col items-end justify-between sm:justify-center gap-2 shrink-0 pt-2 sm:pt-0 sm:pl-4 border-t sm:border-t-0 border-gray-100 min-w-[120px]">
                                      {item.price && (
                                        <div className="text-right">
                                          <div className="text-base font-bold text-gray-900">
                                            <CurFt currency={item?.price?.currency?.name || 'INR'} price={item.price.totalPrice} />
                                          </div>
                                          <div className="text-[11px] text-gray-500 font-medium leading-tight">{'per person'}</div>
                                        </div>
                                      )}

                                      <button
                                        type="button"
                                        onClick={() => SelectActivity(item, index)}
                                        className={`px-5 py-2 rounded-lg text-xs font-bold tracking-wide transition-colors cursor-pointer ${isSelected
                                          ? 'bg-sky-100 text-sky-600 flex items-center gap-1 border border-sky-200'
                                          : 'bg-white border border-blue-600 text-blue-600 hover:bg-blue-50'
                                          }`}
                                      >
                                        {isSelected ? (
                                          <>
                                            <Check className="w-3.5 h-3.5 stroke-[3]" /> SELECTED
                                          </>
                                        ) : (
                                          'SELECT'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="py-16 text-center text-gray-400 text-sm">
                                No transfers available for this date.
                              </div>
                            )}
                          </div>
                        </>
                      )}
                      {activeTab === 'SIGHTSEEING' && (
                        <>
                          {/* Filters and Search Bar */}
                          {/* <div className="p-4 py-2 bg-white flex flex-wrap items-center justify-between gap-4">
                            <div className="flex flex-col gap-1">
                              <label className="text-xs font-semibold text-gray-700">Category</label>
                              <div className="relative">
                                <select className="appearance-none bg-sky-50/60 border border-sky-200 text-blue-600 text-sm font-semibold rounded-lg px-3 py-1.5 pr-8 focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer">
                                  <option>Any</option>
                                  <option>Sightseeing</option>
                                  <option>Workshop</option>
                                  <option>Dining</option>
                                </select>
                                <ChevronDown className="w-4 h-4 text-blue-500 absolute right-2.5 top-1/2 -translate-y-1/2 pointer-events-none" />
                              </div>
                            </div>

                            <div className="flex items-center gap-3">
                              <div className="relative">
                                <Search className="w-4 h-4 text-sky-500 absolute left-3 top-1/2 -translate-y-1/2" />
                                <input
                                  type="text"
                                  placeholder="Search activities"
                                  className="pl-9 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg w-48 sm:w-56 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                              </div>

                              <button type="button" className="flex items-center gap-1 text-sm font-semibold text-gray-800 hover:text-gray-900 cursor-pointer">
                                Sort by <ChevronDown className="w-4 h-4 text-blue-500" />
                              </button>
                            </div>
                          </div> */}

                          {/* Scrollable Content Body */}
                          <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-4">
                            {activeTab === 'SIGHTSEEING' ? (
                              AddSightseeing.length > 0 && AddSightseeing.map((item, index) => {
                                const isSelected = SelectedItinerary?.[selectedDays]?.sightseeings?.includes(item.id)//SelectedSight?.mst_sightseeing_id === item.id;
                                return (
                                  <div
                                    key={item.id}
                                    className="flex flex-col sm:flex-row gap-4 p-4 border border-gray-200 rounded-2xl bg-white shadow-xs hover:shadow-md transition-shadow"
                                  >
                                    <img
                                      src={item?.images || "/placeholder.png"}
                                      onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = "/placeholder.png"; // path to your placeholder image
                                      }}
                                      alt={item.name}
                                      className="w-full sm:w-44 h-36 rounded-xl object-cover shrink-0"
                                    />

                                    <div className="flex-1 flex flex-col justify-between">
                                      <div>
                                        <h4 className="text-base font-bold text-gray-900">{item.name} ({item?.sightseeing_type?.name})</h4>
                                        <div className="text-xs text-gray-600 mt-1 line-clamp-2 leading-relaxed">
                                          <div
                                            className="text-gray-700 text-sm"
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                          />
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium mt-2">
                                          <Clock className="w-3.5 h-3.5 text-gray-500" />
                                          <span>{item.duration}</span>
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-700 font-medium mt-1">
                                          <Car className="w-3.5 h-3.5 text-gray-600 stroke-[3]" />
                                          <span>{item?.price?.booking_included}</span>
                                        </div>
                                      </div>

                                      <div className="mt-2">
                                        <button type="button" className="text-xs font-semibold text-blue-600 hover:underline cursor-pointer">
                                          Know More
                                        </button>
                                      </div>
                                    </div>

                                    {/* Pricing and Action */}
                                    <div className="flex sm:flex-col items-end justify-between sm:justify-center gap-2 shrink-0 pt-2 sm:pt-0 sm:pl-4 border-t sm:border-t-0 border-gray-100 min-w-[120px]">
                                      {item.price && (
                                        <div className="text-right">
                                          <div className="text-base font-bold text-gray-900">
                                            <CurFt currency={item?.price?.currency?.name || 'INR'} price={item.price.totalPrice} />
                                          </div>
                                          <div className="text-[11px] text-gray-500 font-medium leading-tight">{'per person'}</div>
                                        </div>
                                      )}

                                      <button
                                        type="button"
                                        onClick={() => SelectSightseeing(item, index)}
                                        className={`px-5 py-2 rounded-lg text-xs font-bold tracking-wide transition-colors cursor-pointer ${isSelected
                                          ? 'bg-sky-100 text-sky-600 flex items-center gap-1 border border-sky-200'
                                          : 'bg-white border border-blue-600 text-blue-600 hover:bg-blue-50'
                                          }`}
                                      >
                                        {isSelected ? (
                                          <>
                                            <Check className="w-3.5 h-3.5 stroke-[3]" /> SELECTED
                                          </>
                                        ) : (
                                          'SELECT'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="py-16 text-center text-gray-400 text-sm">
                                No transfers available for this date.
                              </div>
                            )}
                          </div>
                        </>
                      )}
                      {activeTab === 'TRANSFERS' && (
                        <>
                          {/* Filters and Search Bar */}
                          <div className="p-4 py-2 bg-white flex flex-wrap items-center justify-between gap-4">

                            <div className="flex items-center gap-3">
                              <div className="relative">
                                <Search className="w-4 h-4 text-sky-500 absolute left-3 top-1/2 -translate-y-1/2" />
                                <input
                                  type="text"
                                  placeholder="Search activities"
                                  className="pl-9 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg w-48 sm:w-56 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                              </div>

                              <button type="button" className="flex items-center gap-1 text-sm font-semibold text-gray-800 hover:text-gray-900 cursor-pointer">
                                Sort by <ChevronDown className="w-4 h-4 text-blue-500" />
                              </button>
                            </div>
                          </div>

                          {/* Scrollable Content Body */}
                          <div className="flex-1 overflow-y-auto px-6 pb-6 space-y-4">
                            {activeTab === 'TRANSFERS' ? (
                              AddVehicle.map((item) => {
                                const isSelected = SelectedItinerary?.[selectedDays]?.selectedcab === item.id;
                                return (
                                  <div
                                    key={item.id}
                                    className="flex flex-col sm:flex-row gap-4 p-4 border border-gray-200 rounded-2xl bg-white shadow-xs hover:shadow-md transition-shadow"
                                  >
                                    <img
                                      src={item.image || "/placeholder.png"}
                                      onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = "/placeholder.png"; // path to your placeholder image
                                      }}
                                      alt={item.name}
                                      className="w-full sm:w-44 h-36 rounded-xl object-cover shrink-0"
                                    />

                                    <div className="flex-1 flex flex-col justify-between">
                                      <div>
                                        <h4 className="text-base font-bold text-gray-900">{item?.price?.booking_basis} ({item.name})</h4>
                                        <div className="text-xs text-gray-600 mt-1 line-clamp-2 leading-relaxed">
                                          {/* {item?.price?.Summary} */}
                                          <span
                                            dangerouslySetInnerHTML={{
                                              __html: item?.price?.Summary
                                            }}
                                          />
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-600 font-medium mt-2">
                                          <Clock className="w-3.5 h-3.5 text-gray-500" />
                                          <span>Duration {item?.price?.Duration} <span className="text-gray-400 text-xs">•</span>
                                            {item?.price?.availabletime}</span>
                                        </div>

                                        <div className="flex items-center gap-1.5 text-xs text-gray-700 font-medium mt-1">
                                          <Car className="w-3.5 h-3.5 text-gray-600 stroke-[3]" />
                                          <span>{item?.price?.booking_included}</span>
                                          <span className="text-gray-400 text-xs">•</span>
                                          <span className='flex items-center gap-2'> <Users className="w-4 h-4 text-gray-500 shrink-0" />Max Pax {item?.price?.max_pax_capacity} </span>
                                          <span className='flex items-center gap-2'> <BriefcaseBusiness className="w-4 h-4 text-gray-500 shrink-0" />Max Luggage {item?.price?.max_luggage_capacity} </span>

                                        </div>
                                      </div>

                                      <div className="mt-2">
                                        <button type="button" className="text-xs font-semibold text-blue-600 hover:underline cursor-pointer">
                                          Know More
                                        </button>
                                      </div>
                                    </div>

                                    {/* Pricing and Action */}
                                    <div className="flex sm:flex-col items-end justify-between sm:justify-center gap-2 shrink-0 pt-2 sm:pt-0 sm:pl-4 border-t sm:border-t-0 border-gray-100 min-w-[120px]">
                                      {item?.price && (
                                        <div className="text-right">
                                          <div className="text-base font-bold text-gray-900">
                                            <CurFt currency={item?.price?.currency?.name || 'INR'} price={item.price.totalPrice} />
                                          </div>
                                          <div className="text-[11px] text-gray-500 font-medium leading-tight">per day</div>
                                        </div>
                                      )}

                                      <button
                                        type="button"
                                        onClick={() => SelectedIdCab(item)}
                                        className={`px-5 py-2 rounded-lg text-xs font-bold tracking-wide transition-colors cursor-pointer ${isSelected
                                          ? 'bg-sky-100 text-sky-600 flex items-center gap-1 border border-sky-200'
                                          : 'bg-white border border-blue-600 text-blue-600 hover:bg-blue-50'
                                          }`}
                                      >
                                        {isSelected ? (
                                          <>
                                            <Check className="w-3.5 h-3.5 stroke-[3]" /> SELECTED
                                          </>
                                        ) : (
                                          'SELECT'
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                );
                              })
                            ) : (
                              <div className="py-16 text-center text-gray-400 text-sm">
                                No transfers available for this date.
                              </div>
                            )}
                          </div>
                        </>
                      )}
                    </>
                  )}

                  <div className="w-full p-4 border-t bg-white">
                    <button type="button" onClick={() => updateDetails()} className="w-full bg-orange-600 text-white font-bold py-2 rounded-xl hover:bg-orange-700 transition shadow-lg shadow-orange-200" > UPDATE PRICE </button>
                  </div>
                </div>
              </div>
            )}


            {CheckPrice && (
              <div className="fixed inset-0 flex items-center justify-center bg-black/40" style={{ zIndex: '999' }}>
                <div className="w-full max-w-lg rounded-lg bg-white shadow-lg p-4 
                      max-h-[80vh] overflow-y-auto">

                  {/* Header */}
                  <div className="flex justify-between items-center mb-4 bg-white z-10">
                    <h2 className="text-lg font-semibold text-gray-800">
                      Price Details
                    </h2>
                    <button
                      onClick={closePopup}
                      className="text-gray-500 hover:text-gray-700 text-xl"
                    >
                      ✕
                    </button>
                  </div>

                  {/* Body */}
                  <div className="space-y-3 text-sm">

                    {/* Package Cost with Plus */}
                    <div className="flex justify-between items-center">
                      <div className="flex items-center gap-2">
                        <button
                          onClick={() => setShowBreakup(!showBreakup)}
                          className="w-5 h-5 flex items-center justify-center 
                           rounded-full border text-xs font-bold"
                        >
                          {showBreakup ? "−" : "+"}
                        </button>
                        <span className="font-medium">Package Cost</span>
                      </div>
                      <span className="font-medium"><CurFt currency={PackagePrice?.currency || 'INR'} price={parseFloat(PackagePrice?.base_price) + parseFloat(PackagePrice?.markupAmount)} /></span>
                    </div>

                    {/* Breakup Section */}
                    {showBreakup && (
                      <div className="ml-7 text-gray-600 space-y-1">
                        {PackagePrice.roomWiseTotal.map((avdates, index) => (
                          <div key={index} className="flex justify-between">
                            <span>Rooms ({(index + 1)})</span>
                            <div>Adult - {avdates?.adults} {(avdates?.childwb > 0) ? 'CWB - ' + avdates?.childwb : ''} {(avdates?.childwob > 0) ? 'CWOB - ' + avdates?.childwob : ''} {(avdates?.infants > 0) ? 'Infant - ' + avdates?.infants : ''}</div>
                            <span className="font-medium"><CurFt currency={PackagePrice?.currency || 'INR'} price={avdates?.base_price + avdates?.markup} /></span>
                          </div>
                        ))}
                      </div>
                    )}

                    <hr />

                    {/* Discount */}
                    {PackagePrice?.discount_amount > 0 && (
                      <div className="flex justify-between text-green-600">
                        <span>Discount</span>
                        <span className="font-medium">- <CurFt currency={PackagePrice?.currency || 'INR'} price={PackagePrice?.discount_amount} /></span>
                      </div>
                    )}

                    {/* After Discount */}
                    <div className="flex justify-between">
                      <span>Package Cost After Discount</span>
                      <span className="font-medium"><CurFt currency={PackagePrice?.currency || 'INR'} price={PackagePrice?.discounted_price} /></span>
                    </div>

                    {/* GST */}
                    <div className="flex justify-between">
                      <span>GST/TAX </span>
                      <span className="font-medium"><CurFt currency={PackagePrice?.currency || 'INR'} price={PackagePrice?.total_tax} /></span>
                    </div>

                    {/* Total */}
                    <div className="flex justify-between">
                      <span>Total Amount</span>
                      <span className="font-medium"><CurFt currency={PackagePrice?.currency || 'INR'} price={PackagePrice?.finalPrice} /></span>
                    </div>
                    {PackagePrice?.discount_amount > 0 && (
                      <div className="flex justify-between items-center border-t pt-3">
                        <span className="flex items-center gap-2 text-green-600 font-medium">
                          ✅ Discount Applied
                        </span>
                        <span className="text-green-600 font-semibold"><CurFt currency={PackagePrice?.currency || 'INR'} price={PackagePrice?.discount_amount} /></span>
                      </div>
                    )}


                    {/* Grand Total */}
                    <div className="bg-gray-100 rounded-md p-4 flex justify-between items-center">
                      <span className="text-base font-semibold">Grand Total</span>
                      <span className="text-lg font-bold"><CurFt currency={PackagePrice?.currency || 'INR'} price={Math.ceil(PackagePrice?.finalPrice)} /></span>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="mt-2 text-right bg-white pt-3">
                    <div className="grid grid-cols-3 gap-2">

                      <button
                        onClick={DownloadItinerary}
                        className="w-full py-3 rounded-lg shadow-md text-sm font-medium bg-gradient-to-r from-orange-600 to-orange-700 hover:from-orange-700 hover:to-orange-800 text-white"
                      >
                        Download Itinerary
                      </button>
                      <button
                        onClick={ShareonWhatsApp}
                        className="w-full py-3 rounded-lg shadow-md text-sm font-medium bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white"
                      >
                        Share On WhatsApp
                      </button>
                      {packageData.package.proposalType === 'booking' && (
                        <button
                          onClick={Continuetopay}
                          className="w-full py-3 rounded-lg shadow-md text-sm font-medium bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
                        >
                          Book Now
                        </button>
                      )}

                    </div>

                  </div>

                </div>
              </div>
            )}
            <Dialog
              open={isModalOpen}
              onClose={() => setIsModal(false)}
              className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
            >
              <div className="bg-white w-full max-w-lg rounded-2xl shadow-lg p-6 max-h-[90vh] overflow-y-auto">
                {/* Header Row */}
                <div className="flex items-center justify-between w-full border-b pb-2 mb-4">
                  <h2 className="text-lg font-semibold">{action}</h2>
                  <button onClick={() => setIsModal(false)} className="text-gray-500 hover:text-gray-700">
                    <X size={20} />
                  </button>
                </div>

                {/* Form */}
                <form className="space-y-4" onSubmit={handleSubmit}>
                  {/* <p className="text-red-500">Error message</p> */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                    {/* Row 1 */}
                    {/* Title */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">Title</label>
                      <select
                        value={formData.title}
                        name="title"
                        onChange={handleChange}
                        className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      >
                        <option value="">Title *</option>
                        <option value="MR">Mr.</option>
                        <option value="MRS">Mrs.</option>
                        <option value="MS">Ms.</option>
                      </select>
                    </div>

                    {/* First Name */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData?.firstName}
                        onChange={handleChange}
                        placeholder="First Name *"
                        className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      />
                    </div>

                    {/* Row 2 */}
                    {/* Last Name */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData?.lastName}
                        onChange={handleChange}
                        placeholder="Last Name *"
                        className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      />
                    </div>

                    {/* Email */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">Email</label>
                      <input
                        type="email"
                        name="email"
                        value={formData?.email}
                        onChange={handleChange}
                        placeholder="Email *"
                        className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all"
                      />
                    </div>

                    {/* Row 3 */}
                    {/* Phone */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">Phone Number</label>
                      <div className="flex gap-2">
                        <div className="w-24">
                          <select
                            name="phoneCode"
                            value={formData?.phoneCode}
                            onChange={handleChange}
                            className="w-full px-2 py-2.5 text-sm border border-gray-300 rounded-lg bg-white focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          >
                            <option value="91">+91</option>
                            <option value="1">+1</option>
                            <option value="44">+44</option>
                            <option value="971">+971</option>
                          </select>
                        </div>
                        <div className="flex-1">
                          <input
                            type="tel"
                            name="mobile"
                            value={formData?.mobile}
                            onChange={handleChange}
                            placeholder="Mobile Number *"
                            className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Departure City */}
                    <div className="flex flex-col">
                      <label className="text-sm font-medium mb-1">Departure City</label>
                      <div className="px-3 py-2.5 text-sm border border-gray-200 rounded-lg bg-gray-50">
                        {packageData?.package?.dep_city_name}
                      </div>
                    </div>

                    {/* Row 4 - Full Width */}
                    <div className="flex flex-col md:col-span-2">
                      {packageData?.package?.PackageCategory === 2 ? (
                        <>
                          <label className="text-sm font-medium mb-1">Package Type : Land Package</label>
                        </>
                      ) : (
                        <>
                          <label className="text-sm font-medium mb-1">Package Type : {packageData?.package?.PackageCategory === 0 ? 'Fixed/Group Departure' : 'FIT (Free/Flexible Independent Traveler)'}</label>
                        </>
                      )}

                    </div>
                    <div className="flex flex-col md:col-span-2">
                      <label className="text-sm font-medium mb-1">Departure Date</label>
                      {packageData?.package?.PackageCategory === 0 ? (
                        <select
                          value={formData.TravelDate}
                          name="TravelDate"
                          onChange={handleChange}
                          className="w-full px-3 py-2.5 text-sm border border-gray-300 rounded-lg focus:ring-1 focus:ring-blue-500 focus:border-blue-500 transition-all"
                        >
                          {packageData?.package.availabledates.map((avdates, index) => (
                            <option key={index} value={avdates.start_date}>{format(new Date(avdates.start_date), "dd-MM-yyyy")}</option>
                          ))}
                        </select>
                      ) : (
                        <DateInput
                          placeholder="dd-mm-yyyy"
                          valueFormat="DD-MM-YYYY"
                          value={formData.TravelDate}
                          minDate={new Date()}
                          maxDate={maxDate}
                          onChange={(date) => handleChange("TravelDate", date)}
                          rightSection={<Calendar size={18} className="text-gray-500" />}
                          readOnly={packageData?.package?.PackageCategory === 0}
                          classNames={{
                            input: "w-full !border !rounded-lg !px-3 !py-2.5",
                          }}
                        />
                      )}
                    </div>

                  </div>

                  {/* Remarks */}
                  <div className="flex flex-col">
                    {packageData?.package?.PackageCategory === 0 ? (
                      <div className="space-y-2">
                        {packages.map((pkg, index) => (
                          <div
                            key={index}
                            className="flex items-center justify-between p-3 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-200"
                          >
                            {/* Left Side: Name and Pricing */}
                            <div className="space-y-1">
                              <h3 className="text-md font-semibold text-gray-900">{pkg.name}</h3>
                              <div className="flex items-center space-x-2 text-sm">
                                <span className="font-semibold text-gray-600">
                                  <CurFt currency={PackagePrice?.currency || 'INR'} price={Math.ceil(pkg.final_price)} /> / Person
                                </span>
                                {pkg.beforediscountprice > pkg.final_price && (
                                  <span className="text-gray-400 line-through decoration-red-500">
                                    <CurFt currency={PackagePrice?.currency || 'INR'} price={Math.ceil(pkg.beforediscountprice)} />
                                  </span>
                                )}
                              </div>
                            </div>

                            {/* Right Side: Quantity Counter */}
                            <div className="flex items-center space-x-6">
                              <button
                                type='button'
                                onClick={() => handleRemoveAdult(index)}
                                disabled={(pkg?.adults || 0) === 0}
                                className={`w-8 h-8 flex items-center justify-center text-xl font-medium rounded-full transition-colors ${(pkg?.adults || 0) === 0
                                  ? 'text-gray-300 cursor-not-allowed'
                                  : 'text-gray-600 hover:bg-gray-100 active:bg-gray-200'}`}
                                aria-label="Remove adult"
                              >
                                −
                              </button>

                              <span className="w-6 text-center text-lg text-gray-800">
                                {(pkg?.adults || 0)}
                              </span>

                              <button
                                type='button'
                                onClick={() => handleAddAdult(index)}
                                className="w-8 h-8 flex items-center justify-center text-xl font-medium text-gray-600 rounded-full hover:bg-gray-100 active:bg-gray-200 transition-colors"
                                aria-label="Add adult"
                              >
                                +
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <>
                        {rooms.map((room, index) => (
                          <div key={index} className="border rounded-xl p-3 mb-3 bg-blue-50">

                            {/* Room Header */}
                            <div className="flex justify-between items-center mb-2">
                              {packageData?.package?.PackageCategory !== 2 && (
                                <h4 className="text-sm font-semibold">Room {room.roomNo}</h4>
                              )}


                              {rooms.length > 1 && (
                                <button
                                  type="button"
                                  onClick={() => removeRoom(index)}
                                  className="text-xs text-red-500 hover:underline"
                                >
                                  Remove
                                </button>
                              )}
                            </div>

                            <div className="grid grid-cols-2 gap-2">

                              {/* Adults */}
                              <div>
                                <label className="block text-xs text-gray-700 mb-1">Adults</label>
                                <div className="flex items-center border rounded-lg bg-white">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      updateRoomPax(index, "adults", room.adults - 1)
                                    }
                                    className="px-2 py-2"
                                  >
                                    <Minus className="w-3.5 h-3.5" />
                                  </button>
                                  <span className="flex-1 text-center text-sm font-medium">
                                    {room.adults}
                                  </span>

                                  <button
                                    type="button"
                                    disabled={getTotalPax(room) >= room.max_pax_stay}
                                    onClick={() =>
                                      updateRoomPax(index, "adults", room.adults + 1)
                                    }
                                    className={`px-2 py-2 ${getTotalPax(room) >= room.max_pax_stay
                                      ? "text-gray-300 cursor-not-allowed"
                                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                                      }`}
                                  >
                                    <Plus className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>

                              {/* Child with bed */}
                              <div>
                                <label className="block text-xs text-gray-700 mb-1">Childs</label>
                                <div className="flex items-center border rounded-lg bg-white">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      updateRoomPax(index, "childWithBed", room.childWithBed - 1)
                                    }
                                    className="px-2 py-2"
                                  >
                                    <Minus className="w-3.5 h-3.5" />
                                  </button>
                                  <span className="flex-1 text-center text-sm font-medium">
                                    {room.childWithBed}
                                  </span>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      updateRoomPax(index, "childWithBed", room.childWithBed + 1)
                                    }
                                    className={`px-2 py-2 ${getTotalPax(room) >= room.max_pax_stay
                                      ? "text-gray-300 cursor-not-allowed"
                                      : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                                      }`}
                                  >
                                    <Plus className="w-3.5 h-3.5" />
                                  </button>
                                </div>
                              </div>

                              {/* Child without bed */}
                              {packageData?.package?.PackageCategory !== 2 && (
                                <div>
                                  <label className="block text-xs text-gray-700 mb-1">Child without bed</label>
                                  <div className="flex items-center border rounded-lg bg-white">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        updateRoomPax(index, "childWithoutBed", room.childWithoutBed - 1)
                                      }
                                      className="px-2 py-2"
                                    >
                                      <Minus className="w-3.5 h-3.5" />
                                    </button>
                                    <span className="flex-1 text-center text-sm font-medium">
                                      {room.childWithoutBed}
                                    </span>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        updateRoomPax(index, "childWithoutBed", room.childWithoutBed + 1)
                                      }
                                      className={`px-2 py-2 ${getTotalPax(room) >= room.max_pax_stay
                                        ? "text-gray-300 cursor-not-allowed"
                                        : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                                        }`}
                                    >
                                      <Plus className="w-3.5 h-3.5" />
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* Infants */}
                              {packageData?.package?.PackageCategory !== 2 && (
                                <div>
                                  <label className="block text-xs text-gray-700 mb-1">Infants</label>
                                  <div className="flex items-center border rounded-lg bg-white">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        updateRoomPax(index, "infants", room.infants - 1)
                                      }
                                      className="px-2 py-2"
                                    >
                                      <Minus className="w-3.5 h-3.5" />
                                    </button>
                                    <span className="flex-1 text-center text-sm font-medium">
                                      {room.infants}
                                    </span>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        updateRoomPax(index, "infants", room.infants + 1)
                                      }
                                      className={`px-2 py-2 ${getTotalPax(room) >= room.max_pax_stay
                                        ? "text-gray-300 cursor-not-allowed"
                                        : "text-gray-600 hover:text-gray-800 hover:bg-gray-50"
                                        }`}
                                    >
                                      <Plus className="w-3.5 h-3.5" />
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                        {packageData?.package.PackageCategory !== 2 && (
                          <button
                            type='button'
                            onClick={addRoom}
                            className="w-full mt-2 text-sm font-medium text-blue-600 border border-dashed rounded-lg py-2 hover:bg-blue-50"
                          >
                            + Add Another Room
                          </button>
                        )}

                      </>
                    )}
                  </div>

                  {/* Submit */}
                  <div className="flex justify-end">
                    <button
                      type="submit"
                      disabled={loadingpoup === true}
                      className={`bg-blue-500 text-white px-5 py-2 rounded-md hover:blue-600 transition ${loadingpoup === true ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500 hover:bg-blue-600"
                        }`}
                    >
                      {loadingpoup === true ? <>Please wait...</> : <>Submit</>}
                    </button>
                  </div>
                </form>
              </div>
            </Dialog>

            <div className="bg-gray-50 min-h-screen font-sans pb-12">
              {loading ? (
                <PackageSkeleton />
              ) : (
                <>

                  <div className="max-w-7xl mx-auto p-4 md:pt-4">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4 gap-4">
                      <div>
                        <div className="flex items-center gap-2 mb-2">
                          <h1 className="text-3xl font-bold text-gray-800">{packageData?.package?.PackageName}</h1>
                          <span className="bg-yellow-100 text-yellow-700 text-xs font-bold px-2 py-1 rounded">{packageData?.package?.ProductCode}</span>
                        </div>
                        <p className="text-gray-500 flex items-center gap-1">
                          <MapPin size={16} className='text-red-500' /> {packageData?.package?.des_city_name} &nbsp;
                          {packageData?.package?.PackageCategory !== 2 && (
                            <>
                              <Users size={16} className='text-green-500' /> Max {packageData?.package?.selected_category?.max_pax_stay} people &nbsp;
                              <Star size={16} className='text-orange-500' /> {packageData?.selected_category?.star} Star
                            </>
                          )}

                        </p>
                      </div>
                      <button onClick={() => EnquiryHand("DOWNLOAD")} type='button' className="flex items-center gap-2 border-2 border-orange-400 text-orange-500 px-4 py-2 rounded-xl font-semibold hover:bg-orange-50 transition">
                        <Download size={18} /> Download PDF
                      </button>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                      {/* Main Content */}
                      <div className="lg:col-span-2 space-y-4">
                        {/* Main Image */}
                        <PremiumSlider images={images} />
                        {/* <div className="relative rounded-2xl overflow-hidden h-[400px] shadow-lg">
                          <img
                            src="https://images.unsplash.com/photo-1593693397690-362cb9666fc2?auto=format&fit=crop&q=80&w=1200"
                            alt="Kerala Tea Gardens"
                            className="w-full h-full object-cover"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                        </div> */}

                        {/* Tabs Navigation */}
                        <div className="sticky top-0 z-50 bg-white shadow-sm">
                          <div className="border-b border-gray-200 py-2 px-2">
                            <div className="flex overflow-x-auto">
                              {TabCategories.map((tab) => (
                                <button
                                  key={tab.id}
                                  onClick={() => scrollToSection(tab.ref, tab.id)}
                                  className={`rounded-xl px-6 py-3 font-medium whitespace-nowrap ${tab.id === selectedTab
                                    ? "text-blue-600 border-b-2 border-blue-600"
                                    : "text-gray-500"
                                    }`}
                                >
                                  {tab.name}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>

                        {/* Package Overview onClick={() => scrollToSection(overviewRef)} */}
                        <section ref={overviewRef}>
                          <h2 className="text-xl font-bold mb-4 text-gray-800">Package Overview</h2>
                          <div className="text-gray-600 leading-relaxed">
                            {packageData?.package?.Summary && (
                              <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: packageData?.package?.Summary }} />
                            )}
                          </div>
                        </section>

                        {/* Hotel Details */}
                        {selectedHotels?.[0]?.['hotel_id'] > 0 && selectedHotels.length > 0 && (
                          <section className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm">
                            {selectedHotels?.[0]['hotel_id'] > 0 && selectedHotels.length > 0 ? (
                              <>
                                <h2 className="text-xl font-bold mb-4 text-gray-800">Hotel Details Options</h2>
                                {selectedHotels.map((item) => (
                                  <div key={item.hotel_id} className="flex flex-col md:flex-row gap-6 mt-2">
                                    <img src={`${item.image}?auto=format&fit=crop&q=80&w=300`}
                                      alt="Hotel"
                                      onError={(e) => {
                                        e.target.onerror = null; // prevent infinite loop
                                        e.target.src = "/noimagefound.jpeg"; // path to your placeholder image
                                      }}
                                      className="w-full md:w-48 h-[110px] object-cover rounded-lg" />
                                    <div className="flex-1">
                                      <h3 className="font-bold text-lg ">{item.hotel_name}&nbsp;
                                        <span className="bg-yellow-100 text-yellow-700 text-xs font-bold px-2 py-1 rounded">{item.property_type}</span>
                                      </h3>
                                      <div className="flex text-yellow-400 ">
                                        {[...Array(item.star_rating)].map((_, i) => <span key={i}>★</span>)}
                                      </div>
                                      <div className="grid grid-cols-1 gap-2 mt-1">
                                        <div className="flex items-center gap-2 text-sm text-gray-600"><MapPin size={14} className="text-green-500" />{item.hotel_address} </div>
                                        <div className="flex items-center gap-2 text-sm text-gray-600">{item.city_name} - {item.hotel_pincode}, {item.state} {item.country}</div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <></>
                            )}

                            {/* <button className="w-full mt-6 py-2 text-blue-600 border border-blue-600 rounded-lg hover:bg-blue-50 font-medium">VIEW MORE</button> */}
                          </section>
                        )}
                        {/* Itinerary */}
                        <section ref={itineraryRef}>
                          <h2 className="text-xl font-bold mb-6 text-gray-800">Day Wise Itinerary</h2>
                          <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:h-full before:w-0.5 before:bg-gray-200">

                            {updatedItinerary.map((item) => (
                              <ItineraryDayCard
                                key={item.id}
                                day={item}
                                handleChangeAddOn={handleChangeAddOn}
                                packageData={packageData}
                                removeActivity={removeActivity}
                              />
                            ))}
                          </div>
                        </section>
                      </div>

                      {/* Sidebar / Booking Card */}
                      <div className="space-y-6">
                        <div className="bg-white rounded-2xl shadow-xl border border-blue-50 overflow-hidden sticky top-6">
                          <div className="bg-blue-50 p-6">
                            {/* {packageData?.selected_category?.beforeDiscountPrice > packageData?.selected_category?.finalPrice && (
                              <p className="text-gray-500 line-through text-sm">Starting from {packageData?.selected_category?.finalPrice}</p>
                            )} */}

                            <div className=" text-sm space-y-3">

                              {/* Package Cost */}
                              <div className="flex justify-between items-center text-gray-800">
                                <span>Package Cost</span>
                                <span className="text-right">
                                  <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.package_price + packageData?.package?.selected_category?.markupAmount} />
                                </span>
                              </div>

                              {/* Transfer Fare */}
                              {packageData?.package?.selected_category?.cabprice > 0 && (
                                <div className="flex justify-between items-center text-gray-800">
                                  <span>Transfer Added</span>
                                  <span className="text-right">
                                    <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.cabprice} />
                                  </span>
                                </div>
                              )}
                              {/* activityprice Fare */}
                              {packageData?.package?.selected_category?.activityprice > 0 && (
                                <div className="flex justify-between items-center text-gray-800">
                                  <span>Activity Added</span>
                                  <span className="text-right">
                                    <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.activityprice} />
                                  </span>
                                </div>
                              )}
                              {/* Transfer Fare */}
                              {packageData?.package?.selected_category?.sightseeingprice > 0 && (
                                <div className="flex justify-between items-center text-gray-800">
                                  <span>Sightseeing Added</span>
                                  <span className="text-right">
                                    <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.sightseeingprice} />
                                  </span>
                                </div>
                              )}
                              {/* Flight Fare */}
                              {packageData?.package?.selected_category?.flightFare > 0 && (
                                <div className="flex justify-between items-center text-gray-800">
                                  <span>Flight Fare </span>
                                  <span className="text-right">
                                    <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.flightFare} />
                                  </span>
                                </div>
                              )}

                              {/* Discount */}
                              {packageData?.package?.selected_category?.discountAmount > 0 && (
                                <div className="flex justify-between items-center text-green-600">
                                  <span>Discount</span>
                                  <span className="text-right">
                                    -<CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.discountAmount} />
                                  </span>
                                </div>
                              )}

                              {/* Cost After Discount */}
                              <div className="flex justify-between items-center font-medium text-gray-800">
                                <span>Total</span>
                                <span className="text-right">
                                  <CurFt
                                    currency={PackagePrice?.currency || 'INR'}
                                    price={
                                      (packageData?.package?.selected_category?.base_price - packageData?.package?.selected_category?.discountAmount) - packageData?.package?.selected_category?.packageTaxAmount
                                    }
                                  />
                                </span>
                              </div>

                              {/* GST / TAX */}
                              {/* <div className="flex justify-between items-center text-gray-600">
                                <span>TAXES</span>
                                <span className="text-right">
                                  <CurFt currency={PackagePrice?.currency || 'INR'} price={packageData?.package?.selected_category?.packageTaxAmount} />
                                </span>
                              </div> */}

                              {/* Divider */}
                              <div className="border-t pt-3 flex justify-between items-end">

                                <span className="text-lg font-bold text-gray-800">
                                  Total Amount
                                </span>

                                <div className="text-right">
                                  <div className="text-lg font-bold text-gray-900">
                                    <CurFt
                                      currency={packageData?.package?.selected_category?.Symbal || "INR"}
                                      price={Math.ceil(packageData?.package?.selected_category?.final_price)}
                                    />
                                  </div>
                                  <div className="text-xs text-gray-500">
                                    Per Person On {packageData?.package?.selected_category?.name}
                                  </div>
                                </div>

                              </div>

                            </div>
                          </div>
                          <div className="p-6 space-y-4">
                            <button type='button' onClick={() => EnquiryHand("BOOK")} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition shadow-lg shadow-blue-200">
                              BOOK NOW
                            </button>
                            <button type='button' onClick={() => EnquiryHand("ENQUIRY")} className="w-full bg-red-600 text-white font-bold py-3 rounded-xl hover:bg-red-700 transition shadow-lg shadow-red-200">
                              ENQUIRY NOW
                            </button>
                            <div className="pt-4 border-t border-gray-100 space-y-3">
                              <div className="flex items-center gap-3 text-gray-700">
                                <Clock size={18} className="text-blue-500" />
                                <span className="text-sm font-medium">Duration: {parseInt(packageData?.package?.PackageDuration)} Nights / {parseInt(packageData?.package?.PackageDuration) + 1} Days</span>
                              </div>
                              <div className="flex items-center gap-3 text-gray-700">
                                <ShieldCheck size={18} className="text-blue-500" />
                                <span className="text-sm font-medium">{packageData?.selected_category?.category_name}</span>
                              </div>
                              <div className="flex items-center gap-3 text-gray-700">
                                <ShieldCheck size={18} className="text-blue-500" />
                                <span className="text-sm font-medium">{packageData?.package?.PackageCategory === 0 ? 'Fixed/Group Departure' : 'FIT (Free/Flexible Independent Traveler)'}</span>
                              </div>
                            </div>
                            <div className="bg-gray-50 p-4 rounded-lg">
                              <p className="text-xs font-bold text-gray-400 uppercase mb-3">Package Includes</p>
                              <div className="grid grid-cols-4 gap-2">
                                {trimmedArray.includes('Hotel') && (
                                  <div className="flex flex-col items-center gap-1 text-[10px] text-gray-500"><Hotel size={20} /> Hotel</div>
                                )}

                                {trimmedArray.includes('Flight') && (
                                  <div className="flex flex-col items-center gap-1 text-gray-400">
                                    <Plane size={20} />
                                    <span className="text-[10px]">Flight</span>
                                  </div>
                                )}

                                {['All Meals - AP', 'Breakfast - CP', 'Breakfast & Dinner - MAP', 'Breakfast & Dinner - MAP'].some(option => trimmedArray.includes(option)) && (
                                  <div className="flex flex-col items-center gap-1 text-[10px] text-gray-500"><Utensils size={20} /> Meals</div>
                                )}

                                {['Cab Transfer', 'Airport Transfers', 'Shuttle Service'].some(option => trimmedArray.includes(option)) && (
                                  <div className="flex flex-col items-center gap-1 text-[10px] text-gray-500"><Car size={20} /> Transfer</div>
                                )}

                                {['Sightseeing'].some(option => trimmedArray.includes(option)) && (
                                  <div className="flex flex-col items-center gap-1 text-[10px] text-gray-500"><Camera size={20} /> Sightseeing</div>
                                )}

                              </div>
                            </div>

                            <div className="bg-blue-100 text-white p-6 rounded-2xl flex items-center gap-4">
                              <div className="bg-white/10 p-3 rounded-full">
                                <Users size={24} className="text-blue-300" />
                              </div>
                              <div>
                                <p className="text-xs text-gray-600 font-bold uppercase">Need Help?</p>
                                <div className="flex items-center gap-2 text-sm mt-1 text-gray-600"><Phone size={14} /> {user?.UserData?.user?.countrycode}-{user?.UserData?.mobile}</div>
                                <div className="flex items-center gap-2 text-sm mt-0.5 text-gray-600"><Mail size={14} /> {user?.UserData?.email}</div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Inclusions & Exclusions */}
                    <div ref={inclusionRef} className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
                      <div className="bg-green-50 p-6 rounded-2xl border border-green-100">
                        <h3 className="text-green-800 font-bold text-lg mb-4 flex items-center gap-2">
                          <CheckCircle2 className="text-green-600" /> Inclusions
                        </h3>
                        <ul className="space-y-3">
                          {packageData?.inclusions.map((item, i) => (
                            <li key={i} className="flex gap-2 text-sm text-green-700">
                              <CheckCircle2 size={16} className="shrink-0 mt-0.5 opacity-50" /> {item}
                            </li>
                          ))}
                          {packageData?.package?.inclusion_summary && (
                            <li className="flex gap-2 text-sm text-green-700">
                              <CheckCircle2 size={16} className="shrink-0 mt-0.5 opacity-50" /> <div className="text-sm text-green-700 leading-relaxed mt-1" dangerouslySetInnerHTML={{ __html: packageData?.package?.inclusion_summary }} />
                            </li>
                          )}
                        </ul>
                      </div>
                      <div className="bg-red-50 p-6 rounded-2xl border border-red-100">
                        <h3 className="text-red-800 font-bold text-lg mb-4 flex items-center gap-2">
                          <XCircle className="text-red-600" /> Exclusions
                        </h3>
                        <ul className="space-y-3">
                          {packageData?.package?.exclusions.map((item, i) => (
                            <li key={i} className="gap-2 text-sm text-red-700">
                              <div className='flex gap-2'>
                                <XCircle size={16} className="shrink-0 mt-0.5 opacity-50" /> {item?.title}
                              </div>
                              <div className="text-sm text-gray-600 leading-relaxed mt-1" dangerouslySetInnerHTML={{ __html: item.summary }} />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Terms and Conditions Section */}
                    <div ref={additionalRef} className="mt-12 bg-white rounded-2xl border border-gray-100 overflow-hidden">
                      <div className="px-6 py-3 border-b border-gray-100">
                        <h2 className="text-xl font-bold">Terms & Conditions</h2>
                      </div>
                      <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-8 text-sm">
                        <div className="space-y-4">
                          <div dangerouslySetInnerHTML={{ __html: policyData[0]?.terms_cond }} />
                        </div>
                        <div className="space-y-4">
                          {/* <div className="bg-blue-50 p-4 rounded-lg">
                            <h4 className="font-bold text-blue-800 mb-1">Remarks</h4>
                            <p className="text-blue-700 italic">Rate is valid with a minimum of 6 Pax traveling together.</p>
                          </div> */}

                          {policyData.length > 0 && (
                            <>
                              <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
                                <div className="policy-card bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm">
                                  <div className="bg-blue-50 border-b border-gray-200 p-3">
                                    <div className="flex items-center">
                                      <svg className="w-5 h-5 mr-2 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                      </svg>
                                      <h3 className="text-lg font-semibold text-gray-700">Payment Policy</h3>
                                    </div>
                                  </div>
                                  <div className="p-0">
                                    <table className="min-w-full">
                                      <thead>
                                        <tr className="bg-gray-50">
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            When to Pay
                                          </th>
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Type
                                          </th>
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Amount
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="divide-y divide-gray-200">
                                        {policyData
                                          .filter(item => item.policy_type === 1).map((policy) => (
                                            <tr key={policy.id}>
                                              <td className="py-2 px-4 text-sm">
                                                {policy.payment_day === 0 ? 'Anytime' : `${policy.payment_day} days `}
                                              </td>
                                              <td className="py-2 px-4 text-sm">
                                                <span className={`px-2 py-1 text-xs rounded-full ${policy.payment_type === 1 ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                                                  {policy.payment_type === 1 ? 'Fixed' : 'Percentage'}
                                                </span>
                                              </td>
                                              <td className="py-2 px-4 text-sm font-medium">
                                                {policy.payment_type === 1
                                                  ? <CurFt currency={PackagePrice?.currency || 'INR'} price={policy.payment_amount} />
                                                  : `${policy.payment_amount}%`}
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>

                                <div className="policy-card bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm">
                                  <div className="bg-red-50 border-b border-gray-200 p-3">
                                    <div className="flex items-center">
                                      <svg className="w-5 h-5 mr-2 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                      </svg>
                                      <h3 className="text-lg font-semibold text-gray-700">Cancellation Policy</h3>
                                    </div>
                                  </div>
                                  <div className="p-0">
                                    <table className="min-w-full">
                                      <thead>
                                        <tr className="bg-gray-50">
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            When Cancelling
                                          </th>
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Type
                                          </th>
                                          <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                            Charges
                                          </th>
                                        </tr>
                                      </thead>
                                      <tbody className="divide-y divide-gray-200">
                                        {policyData
                                          .filter(item => item.policy_type === 2)
                                          .sort((a, b) => a.cancel_day_before - b.cancel_day_before)
                                          .map((policy) => (
                                            <tr key={policy.id}>
                                              <td className="py-2 px-4 text-sm">
                                                {policy.cancel_day_before === 0 ? 'Anytime' : `${policy.cancel_day_before} days before`}
                                              </td>
                                              <td className="py-2 px-4 text-sm">
                                                <span className={`px-2 py-1 text-xs rounded-full ${policy.cancel_type === 1 ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'}`}>
                                                  {policy.cancel_type === 1 ? 'Fixed' : 'Percentage'}
                                                </span>
                                              </td>
                                              <td className="py-2 px-4 text-sm font-medium">
                                                {policy.cancel_type === 1
                                                  ? <CurFt currency={PackagePrice?.currency || 'INR'} price={policy.cancel_amount} />
                                                  : `${policy.cancel_amount}%`}
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}

            </div>
          </div>
        </main>
      </div>
    </>
  );
}
